import React, { Component } from "react";
import { alterarSenha } from "../../crud/auth.crud";
import { Formik } from 'formik';
import { FormControl, FormHelperText, TextField } from "@material-ui/core";
import Swal from "sweetalert2";

function validateReset(values) {
	const errors = {};

	if (!values.password) {
		errors.password = "A senha é uma informação obrigatória.";
	} else if (values.password.length < 6) {
		errors.password = "A senha deve ter no mínimo 6 caracteres.";
	}

	if (values.password !== values.password_confirmation) {
		errors.password_confirmation = "As senhas não conferem.";
	}

	return errors;
}

class ResetPassword extends Component {
	constructor() {
		super();

		const params = new URLSearchParams(window.location.search);

		this.state = {
			loading: false,
			loadingButtonStyle: { paddingRight: "2.5rem" },
			token: params.get('token'),
			email: params.get('email'),
		};
	}

	enableLoading = () => {
		this.setState({ loading: true, loadingButtonStyle: { paddingRight: "3.5rem" } });
	};

	disableLoading = () => {
		this.setState({ loading: false, loadingButtonStyle: { paddingRight: "2.5rem" } });
	};

	submit = values => {
		this.enableLoading();

		alterarSenha({ ...values, token: this.state.token, email: this.state.email }).then(() => {
			Swal.fire('Tudo certo!', 'Senha alterada com sucesso!', 'success').then((result) => {
				if (result.isConfirmed) window.location.href = '/auth/login';
			});
		}).catch(({ response }) => {
			if (response.data.errors.token) return Swal.fire('Ops!', "Você precisa ter um token de autentificação para alterar sua senha.", 'error');
			else if (response.data.errors) return Swal.fire('Ops!', response.data.errors[0], 'error');
			else return Swal.fire('Ops!', 'Houve um problema. Entre em contato com o suporte.', 'error');
		}).finally(() => {
			this.disableLoading();
		});
	}

	render = () => {
		return (
			<>
				<div className="kt-login__head"></div>

				<div className="kt-login__body">
					<div className="kt-login__form">
						<div className="kt-login__title">
							<h3>Altere sua senha</h3>
							<p>Insira sua nova senha para {this.state.email}.</p>
						</div>

						<Formik initialValues={{ password: '', password_confirmation: '' }} validate={(values) => validateReset(values)} onSubmit={values => this.submit(values)}>
							{({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
								<form noValidate={true} autoComplete="off" className="kt-form" onSubmit={handleSubmit}>
									<FormControl fullWidth error={Boolean(touched.password && errors.password)} className="mt-3">
										<TextField type="password" variant="outlined" name="password" label="Nova senha"
											onBlur={handleBlur} onChange={handleChange} value={values.password}
											error={Boolean(touched.password && errors.password)} />
										{touched.password && errors.password ? <FormHelperText>{errors.password}</FormHelperText> : null}
									</FormControl>

									<FormControl fullWidth error={Boolean(touched.password_confirmation && errors.password_confirmation)} className="mt-3">
										<TextField type="password" variant="outlined" name="password_confirmation" label="Confirmar senha"
											onBlur={handleBlur} onChange={handleChange} value={values.password_confirmation}
											error={Boolean(touched.password_confirmation && errors.password_confirmation)} />
										{touched.password_confirmation && errors.password_confirmation ? <FormHelperText>{errors.password_confirmation}</FormHelperText> : null}
									</FormControl>

									<div className="kt-login__actions">
										<button id="kt_login_reset_submit" type="submit" className={`btn btn-primary btn-elevate kt-login__btn-primary`}
											style={this.state.loadingButtonStyle}>Alterar!</button>
									</div>
								</form>
							)}
						</Formik>
					</div>
				</div>
			</>
		);
	}
}

export default ResetPassword;
